/**
 * A navigation guard helper function
 *
 * @param {route} toRoute - the route object that is about to be navigated to
 * @param {function} callback - a callback function that receive route object
 *                              as its first parameter. i.e. next() / route.push()
 */
import store from '@/store';
// TODO: Look into make this more modular, so that more guards can be added without making this thing more complex
export default (toRoute, callback) => {
  const navigate = (incoming) => {
    if (incoming == null) callback();
    else if (toRoute.path === (incoming.path || incoming)) callback(); // prevent infinite self redirection loop
    else callback(incoming);
  };

  // Always navigate to guest route without checking
  if (toRoute.meta.guest) return navigate();

  // Otherwise, check for authorisation
  // Router will use localStorage to check is the user is authorized to enter
  const hasUserLogin = !!localStorage.getItem('access_token');
  // Guard against unauthorized access
  if (!hasUserLogin) {
    return navigate({
      path: '/login',
      query: {
        redirect: toRoute.fullPath,
        art_intent: 'nav-guarded',
      },
    });
  }

  // Here, user should have successfully login.
  // Check for sign up flow
  const needSignupFlow = store.state.account.needSignup;

  // Perform redirection only when needSignupFlow is ready
  if (needSignupFlow !== null) {
    // Find a suitable place for the user (they can land in any of these step)
    if (needSignupFlow === true) {
      if (store.state.account.shouldAskForVerification || store.state.account.shouldAskForAddingEmail) {
        return navigate('/signup/email');
      } else if (store.state.account.shouldAskForAgreement) {
        return navigate('/signup/agreement');
      } else if (store.state.account.shouldAskForSignup) {
        return navigate('/signup');
      } else {
        return navigate('/signup');
      }
    // If user has no need to sign up, but still navigate to signup, kick them back to profile
    } else if (toRoute.path.startsWith('/signup')) {
      return navigate('/profile');
    }
  }

  return navigate();
};



// WEBPACK FOOTER //
// ./src/utils/navGuard.js